import classNames from 'classnames';
import React, { useEffect } from 'react';
import { HtmlContent } from 'utils';

import styles from './styles/slider_component.module.scss'

const SliderComponent = ({ description, title, slides }) => {
  const slideRef = React.useRef();
  const slidesRef = React.useRef();
  const debounceRef = React.useRef(false);
  const slideIndexRef = React.useRef(0);
  const [slideIndex, setSlideIndex] = React.useState(0);

  const handleSlider = () => {
    if (!slideRef.current || !slidesRef.current) return;

    const sliderSize = slideRef.current.clientWidth;
    const slides = slidesRef.current.children;

    for (let slide of slides) {
      slide.style.transform = `translateX(-${slideIndexRef.current * sliderSize}px)`;
    }
  };

  const handleDebouncedSlider = () => {
    if (debounceRef.current === false) {
      debounceRef.current = true;
      setTimeout(() => {
        handleSlider();
        debounceRef.current = false;
      }, 500);
    }
  };

  const changeSlide = (newIndex) => {
    slideIndexRef.current = newIndex;
    setSlideIndex(newIndex);
    handleSlider();
  }

  const handleBack = () => {
    let newIndex;
    if (slideIndexRef.current === 0) {
      newIndex = slides.length - 1
    } else {
      newIndex = slideIndexRef.current - 1
    }
    changeSlide(newIndex);
  };

  const handleNext = () => {
    let newIndex;
    if (slideIndexRef.current === slides.length - 1) {
      newIndex = 0;
    } else {
      newIndex = slideIndexRef.current + 1;
    }
    changeSlide(newIndex);
  };

  useEffect(() => {
    handleSlider();
  }, [slideIndex]);

  useEffect(() => {
    window.addEventListener('resize', handleDebouncedSlider);

    return () => {
      window.removeEventListener('resize', handleDebouncedSlider);
    };
  }, []);

  return (
    <section className={styles.how_gallery}>
      <div className={styles.how_gallery__main}>
        <h2 className={styles.how_gallery__title}>{title}</h2>
        {
          description !== ''
            ? <HtmlContent content={description} className={styles.how_gallery__description} />
            : null
        }
      </div>
      <div ref={slideRef} className={styles.how_gallery__slider}>
        <ul ref={slidesRef} className={styles.how_gallery__slider__slides}>
          {slides.map((item) => (
            <li
              key={item.id}
              className={styles.how_gallery__slider__slides_item}
            >
              <img loading="lazy"
                src={item.image}
                width='634px'
                height='305px'
                alt={item.title}
                className={styles.how_gallery__slider__slides_image}
              />
              {item.title !== '' ? (
                <div className={styles.slides_item__title}>
                  {item.title}
                </div>
              ) : null}
            </li>
          ))
          }
        </ul>
        {
          slides?.length > 1 ?
            <div className={styles.how_gallery__slider__controls}>
              <div className={styles.how_gallery__slider__controls_dots}>
                {slides?.map((item, index) => (
                  <button
                    key={item.id}
                    type='button'
                    onClick={() => changeSlide(index)}
                    className={
                      classNames({
                        [styles.controls_dots_dot]: true,
                        [styles['controls_dots_dot--active']]: index === slideIndex
                      })
                    }
                  ></button>
                ))
                }
              </div>
              <div className={styles.how_gallery__slider__controls__arrows}>
                <button
                  onClick={handleBack}
                  type='button'
                  className={styles.controls_arrows}
                >
                  <span className={styles.controls_arrows_arrow_inner_back}></span>
                </button>
                <button
                  onClick={handleNext}
                  type='button'
                  className={styles.controls_arrows}
                >
                  <span className={styles.controls_arrows_arrow_inner_frv}></span>
                </button>
              </div>
            </div>
            : null
        }
      </div>
    </section>
  )
}

export default SliderComponent